<template>
    <div
        class="strategy-module__container pb-show-display"
        :data-pblog="pblogData"
    >
        <strategy-card
            :strategy-tag="strategyTag"
            title="攻略专区"
            class="strategy-card"
            bg-color="#F8F8F8"
            @handleCategoryClick="handleTagClick"
            @seeMoreContent="handleTagClick('')"
        />
        <div class="strategy-list__container">
            <div class="strategy-list">
                <strategy-item
                    v-for="(item, index) in strategyList"
                    :key="index"
                    :content="item"
                    bg-color="#F8F8F8"
                    class="strategy-item pb-show-display"
                    :data-pblog="JSON.stringify({
                        value: 'strategyItem',
                        ext: {
                            item: [
                                {
                                    id: '',
                                    ext: Object.assign(
                                        {
                                            moduleName: '攻略专区',
                                            strategyId: item.rid,
                                            strategyName: item.name,
                                            tab: 'detail'
                                        }, $root.extData),
                                    pos: '',
                                },
                            ],
                        },
                    })"
                    @click.native="handleStrategyClick(item)"
                />
                <div
                    class="more__block"
                    v-if="strategyList.length > 1"
                    @click="handleTagClick('')"
                >
                    <div class="more__block-text">查看更多</div>
                    <div class="arrow"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import strategyCard from '@/components/answer/strategy-card.vue';
    import strategyItem from '@/components/answer/strategy-item.vue';
    import { getCurrentInstance, nextTick } from '@vue/composition-api';
    import { eventBus } from '../../index';
    import {ZONE_ANCHOR_TO_STRATEGY_TAG} from '@/common/js/Constant';
    import {openPage} from '@/utils/utility';
    export default {
        components: {
            strategyCard,
            strategyItem,
        },
        props: {
            strategyTag: {
                type: Array,
                default: () => ([]),
            },
            strategyList: {
                type: Array,
                default: () => ([]),
            },
            appId: {
                type: String,
                default: '',
            },
        },
        setup(props) {
            const {proxy} = getCurrentInstance();
            const LOG = proxy.$logger;
            const strategyTabIndex = proxy.$root.tabs.indexOf('攻略');
            const handleTagClick = tag => {
                proxy.$root.tabIndex = strategyTabIndex;
                nextTick(() => {
                    eventBus.$emit(ZONE_ANCHOR_TO_STRATEGY_TAG, tag);
                    window.scrollTo({top: 0});
                });
                LOG.shortcut('click', {value: 'strategyCategory'}, {
                    ...proxy.$root.extData,
                    moduleName: '攻略专区',
                    categoryName: tag,
                    tab: 'detail',
                });
            };
            const pblogData = JSON.stringify({
                value: 'module',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: Object.assign({moduleName: '攻略专区', tab: 'detail'}, proxy.$root.extData),
                            pos: '',
                        },
                    ],
                },
            });
            const handleStrategyClick = strategy => {
                LOG.shortcut('click', {value: 'strategyItem'}, {
                    ...proxy.$root.extData,
                    moduleName: '攻略专区',
                    strategyId: strategy.rid,
                    strategyName: strategy.name,
                    tab: 'detail',
                }, () => {
                    openPage('strategy-detail', {
                        appId: props.appId,
                        rid: strategy.rid,
                    });
                });
            };
            return {
                pblogData,
                handleTagClick,
                handleStrategyClick,
            };
        },
    };
</script>

<style lang="scss" scoped>
@import "~@/common/style/mixin/utils";
$design-width: 1242;
.strategy-module__container {
    .strategy-card {
        padding: 0 px2rem(51);
    }
    .strategy-list__container {
        margin-top: px2rem(15);
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
        overflow-x: scroll;
        overflow-y: hidden;
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
        .strategy-list {
            width: max-content;
            display: flex;
            align-items: center;
            .strategy-item {
                width: px2rem(810);
                margin-left: px2rem(30);
                &:first-child {
                    margin-left: px2rem(51);
                }
            }
            .more__block {
                height: px2rem(863);
                padding: 0 px2rem(36);
                margin: 0 px2rem(51);
                .more__block-text {
                    margin-top: px2rem(297);
                    width: px2rem(45);
                    font-size: px2rem(45);
                    color: #1F1F1F;
                    font-weight: 400;
                    line-height: px2rem(54);
                }
                .arrow {
                    margin-top: px2rem(6);
                    width: px2rem(45);
                    height: px2rem(45);
                    background-image: url('~public/assets/imgs/strategy_list_arrow_right.png');
                    background-size: cover;
                    background-repeat: no-repeat;
                }
            }
        }
    }
}
</style>